export default "__VITE_ASSET__dc10dac2__"